package com.schoolconnect.app.feature.examresults

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun ExamResultsFeatureRoute(
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    val viewModel = remember { ExamResultsViewModel() }
    val state by viewModel.uiState.collectAsState()
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    ExamResultsScreen(state, viewModel::onEvent, onBack, shellRoleCode, shellSchoolLabel, onChangeRole, onLogout)
}
